import UsersApi from "Classes/API/UsersApi";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState, useContext, useMemo, memo } from "react";
import ChartComponent from "./ChartComponent";
import { Card, CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import NationalityGroupCycleChart from "./NationalityGroupCucleChart";
import Loader from "layouts/loader/loader";
import { LanguageContext } from "App";
const MemoizedChartComponent = memo(ChartComponent);
const MemoizedNationalityGroupChart = memo(NationalityGroupCycleChart);

const UserStatistics = () => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ageLabels, setAgeLabels] = useState([]);
  const [ageValues, setAgeValues] = useState([]);
  const [totalAgesCount, setTotalAgesCount] = useState(0);

  const [genderLabels, setGenderLabels] = useState([]);
  const [genderValues, setGenderValues] = useState([]);
  const [totalGenderCount, setTotalGenderCount] = useState(0);
  const { translations } = useContext(LanguageContext);
  const [nationalityLabels, setNationalityLabels] = useState([]);
  const [nationalityValues, setNationalityValues] = useState([]);
  const [totalNationalityCount, setTotalNationalityCount] = useState(0);

  const [nationalityGroupLabels, setNationalityGroupLabels] = useState([]);
  const [nationalityGroupValues, setNationalityGroupValues] = useState([]);
  const [totalNationalityGroupCount, setTotalNationalityGroupCount] = useState(0);
  const [allData, setAllData] = useState({
    ages: [],
    genders: [],
    nationalities: [],
    nationalityGroups: [],
  });
  const totals = useMemo(
    () => ({
      ages: allData.ages.reduce((a, b) => a + (b.count || 0), 0),
      genders: allData.genders.reduce((a, b) => a + (b.count || 0), 0),
      nationalities: allData.nationalities.reduce((a, b) => a + (b.count || 0), 0),
      nationalityGroups: allData.nationalityGroups.reduce((a, b) => a + (b.count || 0), 0),
    }),
    [allData]
  );

  const userAgesChart = useMemo(
    () => ({
      labels: allData.ages.map((item) => item.type || "Unknown"),
      datasets: [
        {
          label: "Count",
          data: allData.ages.map((item) => item.count),
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [allData.ages]
  );

  const userGenderChart = useMemo(
    () => ({
      labels: allData.genders.map((item) => item.type || "Unknown"),
      datasets: [
        {
          label: "Count",
          data: allData.genders.map((item) => item.count),
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [allData.genders]
  );

  const userNationalityChart = useMemo(
    () => ({
      labels: allData.nationalities.map((item) => item.type || "Unknown"),
      datasets: [
        {
          label: "Count",
          data: allData.nationalities.map((item) => item.count),
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [allData.nationalities]
  );

  useEffect(() => {
    const getUsersData = async () => {
      try {
        const result = await UsersApi.getUsersData();
        setAllData(
          result.data || {
            ages: [],
            genders: [],
            nationalities: [],
            nationalityGroups: [],
          }
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setLoading(false);
      }
    };

    getUsersData();
  }, []);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        {loading ? (
          <Loader />
        ) : (
          <div className="container">
            <div className="row" style={{ width: "110%" }}>
              <div className="col-md-12">
                {/* Nationality Group Chart */}
                <div
                  className="col-md-12 mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <CardHeader title={translations.StasticsFeedbackUserspernationalitygroup} />
                      <span className="text-success mx-4 my-4">
                        {totals.nationalityGroups} {translations.StasticsFeedbackrecords}
                      </span>
                    </div>
                    <MDBox mb={3} style={{ width: "40%", margin: "0 auto" }}>
                      <MemoizedNationalityGroupChart
                        nationalityGroups={allData.nationalityGroups}
                      />
                    </MDBox>
                  </Card>
                </div>

                {/* Age Chart */}
                <div
                  className="col-md-12 mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <CardHeader title={translations.StasticsFeedbackUsersage} />
                      <span className="text-success mx-4 my-4">
                        {totals.ages} {translations.StasticsFeedbackrecords}
                      </span>
                    </div>
                    <MDBox mb={3}>
                      <MemoizedChartComponent chartData={userAgesChart} />
                    </MDBox>
                  </Card>
                </div>

                {/* Gender Chart */}
                <div
                  className="col-md-12 mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <CardHeader title={translations.StasticsFeedbackUserspergender} />
                      <span className="text-success mx-4 my-4">
                        {totals.genders} {translations.StasticsFeedbackrecords}
                      </span>
                    </div>
                    <MDBox mb={3}>
                      <MemoizedChartComponent chartData={userGenderChart} />
                    </MDBox>
                  </Card>
                </div>

                {/* Nationality Chart */}
                <div
                  className="col-md-12 mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <CardHeader title={translations.StasticsFeedbackUserspernationality} />
                      <span className="text-success mx-4 my-4">
                        {totals.nationalities} {translations.StasticsFeedbackrecords}
                      </span>
                    </div>
                    <MDBox mb={3}>
                      <MemoizedChartComponent chartData={userNationalityChart} />
                    </MDBox>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        )}
      </DashboardLayout>
    </>
  );
};

export default UserStatistics;
